import keycloakService from "../modules";
import setAuthToken from "../utils/setAuthToken";
export  const routeVerify=()=>{
     const token = keycloakService.getToken();
      const email = keycloakService.getUserInfo('email');
      const dob = keycloakService.getUserInfo('birthdate');
      const candidatename = keycloakService.getUserInfo('name');
      // const phoneNumber = keycloakService.getUserInfo('phone_number');

      localStorage.setItem('mhet_cnd_project', 'mhcet');
      localStorage.setItem('mhet_cnd_token', token);
      localStorage.setItem('mhet_mst_token', token);
      localStorage.setItem('mhet_cnd_email', email);
      localStorage.setItem('mhcet_dob',dob)
      localStorage.setItem('mhcet_name',candidatename)
      // localStorage.setItem('mhet_cnd_mobileno', phoneNumber);
      localStorage.setItem('uploaddetails', 'true');

      setAuthToken(token);
}